import axios from 'axios';
import { toast } from 'react-hot-toast';
import XConstants from '../core/config/Constants';

export default class XApi {

  static async post(endpoint: string, data: any, headers: any = {}, params: any = {}): Promise<any> {
    const url = `${XConstants.httpPrefix}://${XConstants.apiDomain}/apis/v1/core${endpoint}`;
    console.log(url);
    const body = JSON.stringify(data);
    console.log(body);
    try {
      const response = await axios.post(url, body, { headers, params });
      console.log(response.data);
      toast.dismiss();
      return response.data;
    } catch (error: any) {
      toast.dismiss();
      const responseBody = error.response.data;
      toast.error(responseBody.message);
      return null;
    }
  }

  static async get(endpoint: string, headers: any = {}, params: any = {}): Promise<any> {
    const url = `${XConstants.httpPrefix}://${XConstants.apiDomain}/apis/v1/core${endpoint}`;
    console.log(url);
    try {
      const response = await axios.get(url, { headers, params });
      console.log(response.data);
      toast.dismiss();
      return response.data;
    } catch (error: any) {
      const responseBody = error.response.data;
      toast.error(responseBody.message);
      return null;
    }
  }

  static async delete(endpoint: string, headers: any = {}, params: any = {}): Promise<any> {
    const url = `${XConstants.httpPrefix}://${XConstants.apiDomain}/apis/v1/core${endpoint}`;
    console.log(url);
    try {
      const response = await axios.delete(url, { headers, params });
      console.log(response.data);
      toast.dismiss();
      return response.data;
    } catch (error: any) {
      toast.dismiss();
      const responseBody = error.response.data;
      toast.error(responseBody.message);
      return null;
    }
  }

  static async patch(endpoint: string, data: any, headers: any = {}): Promise<any> {
    const url = `${XConstants.httpPrefix}://${XConstants.apiDomain}/apis/v1/core${endpoint}`;
    console.log(url);
    const body = JSON.stringify(data);
    try {
      const response = await axios.patch(url, body, { headers });
      console.log(response.data);
      toast.dismiss();
      return response.data;
    } catch (error: any) {
      console.log(error);
      toast.dismiss();
      const responseBody = error.response.data;
      toast.error(responseBody.message);
      return null;
    }
  }

  static async upload(endpoint: string, headers: any = {}, files: any[], data: any = {}): Promise<any> {
    const url = `${XConstants.httpPrefix}://${XConstants.apiDomain}/apis/v1/core${endpoint}`;
    console.log(url);
    const formData = new FormData();
    for (const key in data) {
      // @ts-ignore
      formData.append(key, data[key]);
    }
    for (let x = 0; x < files.length; x++) {
      console.log('file', files[x]);
      formData.append('files', files[x]);
    }

    try {
      console.log('formData', formData);
      const response = await axios.post(url, formData, {
        headers: {
          ...headers,
          'Content-Type': 'multipart/form-data',
        },
      });
      console.log(response.data);
      toast.dismiss();
      return response.data;
    } catch (error: any) {
      const responseBody = error.response.data;
      toast.error(responseBody.message);
      return null;
    }
  }
}